import styled from "styled-components"

export const ReviewPlanWrapper = styled.div`
  --mesh-header-offset: 44px;

  height: 100%;
  background: linear-gradient(180deg, #00263a 53.39%, #141415 100%);
  color: #fff;
`

export const ReviewPlanHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 44px;
  padding: 0 var(--app-horizontal-padding);
`

export const ReviewPlanContent = styled.div`
  height: calc(100% - var(--app-header-height));
  position: relative;
  padding: 12px var(--app-horizontal-padding);
  display: flex;
  flex-direction: column;
  gap: var(--spacing_l, 16px);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  padding-bottom: var(--cta-height);
`
